let paymentMethods = [{
        label: 'Cash',
        value: 'cash',
        color: '#8e44ad',
    },
    {
        label: 'Bank',
        value: 'bank',
        color: '#535c68',
    },
    {
        label: 'Card',
        value: 'card',
        color: '#22a6b3',
    },
    {
        label: 'Mobile payment',
        value: 'mobilePayment',
        color: '#22a6b3',
    },
    {
        label: 'Other',
        value: 'other',
        color: '#e67e22',
    },
    {
        label: 'User balance',
        value: 'userBalance',
        color: '#27ae60',
    },
    {
        label: 'Guarantee',
        value: 'guarantee',
        color: '#27ae60',
    },
]
export default function (method) {
    let currentIdx = paymentMethods.findIndex(row => row.value === method);
    return paymentMethods[currentIdx];
}

export {
    paymentMethods
};
